import { useIntl } from 'react-intl';

import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { xdlPaletteMint07 } from '@xing-com/tokens';

import { PeakAndPopSkills } from '../../components/peak-and-pop/peak-and-pop-skills';
import { Tile } from '../../components/tile';
import { useDeckCardTyped } from '../../context';

export const SkillsTile: React.FC = () => {
  const { isLoggedOut } = useLoginState();
  const intl = useIntl();
  const { data } = useDeckCardTyped(['TakenJob', 'AvailableJob'] as const);
  let skillsMatchedCount = data?.skillsMatchedCount;
  let skillsTotal = data?.skillsTotal;

  // Logged out dummy values
  if (isLoggedOut) {
    skillsMatchedCount = 5;
    skillsTotal = 10;
  }

  if (!skillsMatchedCount || !skillsTotal) {
    return null;
  }

  return (
    <Tile
      label={intl.formatMessage({
        id: 'DREAM_MACHINE_JOB_CARD_SKILLS_TILE_TITLE',
      })}
      title={`${skillsMatchedCount}/${skillsTotal}`}
      trackTileName="skills"
      progressBar={{
        progress: (skillsMatchedCount / skillsTotal) * 100,
        showLabel: false,
        progressBarColor: xdlPaletteMint07,
      }}
      PeakAndPop={PeakAndPopSkills}
      isBlurred={isLoggedOut}
    />
  );
};
